import {
  ClientProfileOwnerType,
  OrderClientProfileSummary,
  OrderOrganizationOneTimeRequestSummary,
} from "@/components/orders/types";

export type { ClientProfileOwnerType };

export type ClientProfileSummaryFor<T extends ClientProfileOwnerType> =
  OrderClientProfileSummary & { ownerType: T };

export interface RendererLocationSchedule {
  locationId: string;
  scheduledDate: Date | string;
}

export interface RendererOrderClient {
  name?: string;
  email?: string;
  phoneNumber?: string;
}

export interface RendererOrder {
  client?: RendererOrderClient;
  clientProfile?: OrderClientProfileSummary | null;
  organizationOneTimeRequest?: OrderOrganizationOneTimeRequestSummary | null;
  locationSchedules?: RendererLocationSchedule[];
}

export type OrderWithClientProfile<
  T extends ClientProfileOwnerType = ClientProfileOwnerType
> = RendererOrder & {
  clientProfile: ClientProfileSummaryFor<T>;
};

export const assertNeverClientProfileType = (value: never): never => {
  throw new Error(`Unhandled client profile owner type: ${String(value)}`);
};
